const NGA = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="512"
    height="512"
    viewBox="0 0 512 512"
    {...props}
  >
    <mask id="a">
      <circle cx="256" cy="256" r="256" fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#6da544"
        d="M0 0v512h160l96-64 96 64h160V0H352l-96 64-96-64Z"
      />
      <path fill="#eee" d="M160 0h192v512H160Z" />
    </g>
  </svg>
);
export default NGA;
